/// <reference path="../../apps/accounting/accounting.ts" />
/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../common/navigation/navigation.ts" />
/// <reference path="../../crm/entitieslist/entitieslist.ts" />

namespace OfficeGuy.Apps {
    export class Billing {
        static SchemaID_CreditCardPaymentMethod: any;

        static ChargeDocumentSelected(EntityPicker, SupportsTax) {
            var $EntityPicker = $(EntityPicker);
            var PreviousValue = $EntityPicker.data("previousvalue")
            $EntityPicker.data("previousvalue", $EntityPicker.val());
            if ($EntityPicker.val() == ""
                || $EntityPicker.val() == "0"
                || $EntityPicker.val() == "3"
                || $EntityPicker.val() == "12"
                || (PreviousValue != null && PreviousValue != "" && PreviousValue != "0" && PreviousValue != "3" && PreviousValue != "12"))
                return;

            if (SupportsTax)
                Modals.ShowMessageDialog("סוג מסמך", "לתשומת הלב, ישנה חובה חוקית להנפקת חשבונית/קבלה מיד בעד ביצוע החיוב.<br />מומלץ לוודא שאתם יודעים אתם עושים, או להיוועץ עם רואה חשבון.");
            else
                Modals.ShowMessageDialog("סוג מסמך", "לתשומת הלב, ישנה חובה חוקית להנפקת קבלה מיד בעד ביצוע החיוב.<br />מומלץ לוודא שאתם יודעים אתם עושים, או להיוועץ עם רואה חשבון.");
        }

        static BillingCustomerSelected($EntityPicker, IsRecurring, IsExternal): void {
            var Data = Teva.SelectBox.GetInstance($EntityPicker).SelectedData;
            var ActivePaymentMethod = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Billing.Customers.Customers.ActivePaymentMethod"];
            if (ActivePaymentMethod == "")
                ActivePaymentMethod = null;
            var CustomerCompanyNumber = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Customers.CustomersSuppliers.CompanyNumber"];
            var CustomerName = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Customers.CustomersSuppliers.FullName"];
            var BankNumber = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.ActiveBankAccount,Accounting.BankAccounts.BankNumber"];
            var BranchNumber = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.ActiveBankAccount,Accounting.BankAccounts.BranchNumber"];
            var AccountNumber = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.ActiveBankAccount,Accounting.BankAccounts.AccountNumber"];
            var PayingCustomer = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Billing.Customers.Customers.PayingCustomer"];
            var HistoryPaymentMethods = !Data || !Data.AdditionalFields || !Data.AdditionalFields["Billing.Customers.Customers.PaymentMethods"] ? null : Array.isArray(Data.AdditionalFields["Billing.Customers.Customers.PaymentMethods"]) ? Data.AdditionalFields["Billing.Customers.Customers.PaymentMethods"] : [Data.AdditionalFields["Billing.Customers.Customers.PaymentMethods"]];
            var HistoryPaymentMethodID = $("#PaymentMethodID").val() ? $("#PaymentMethodID").val() : null;

            if (Data != null) {
                if ($(".og-accounting-vatrate input:hidden").data("originalvalue") == null)
                    $(".og-accounting-vatrate input:hidden").data("originalvalue", $(".og-accounting-vatrate input:hidden:last").val());
                var NewValue = Data && Data.AdditionalFields && Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.NoVAT"] == true ? "0" : $(".og-accounting-vatrate input:hidden").data("originalvalue");
                Accounting.SelectedCustomer_NoVAT = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.NoVAT"];
                if ($(".og-accounting-vatrate input:hidden:last").val() != NewValue) {
                    if (IsRecurring == true) {
                        if (Accounting.SelectedCustomer_NoVAT == true)
                            OfficeGuy.Modals.ShowMessageDialog("לקוח/ה פטור/ה ממע\"מ", "לתשומת הלב, בחרת לקוח/ה <u>עם</u> הגדרה של \"פטור ממע\"מ\".<br />משום כך סכום המע\"מ במסמך הוגדר כ-0%.<br />ניתן לשנות הגדרה זו בכל עת בכרטיס הלקוח/ה.<br />ההגדרה בכרטיס הלקוח/ה תשפיע על חיוב הוראת הקבע כל עוד הוא יימשך.<br /><br />בשל המורכבות, מומלץ מאוד לוודא שהסכום תחת סה\"כ הינו תואם את הסכום שאליו התכוונת.")
                        else
                            OfficeGuy.Modals.ShowMessageDialog("לקוח/ה חייב/ת במע\"מ", "לתשומת הלב, בחרת לקוח/ה <u>ללא</u> הגדרה של \"פטור ממע\"מ\".<br />משום כך סכום המע\"מ עודכן למע\"מ הנהוג כיום.<br />ניתן לשנות הגדרה זו בכל עת בכרטיס הלקוח/ה.<br />ההגדרה בכרטיס הלקוח/ה תשפיע על חיוב הוראת הקבע כל עוד הוא יימשך.");
                    }
                    else
                        Apps.Accounting.ShowCustomerNoVatChangedModal(Accounting.SelectedCustomer_NoVAT);
                    if (IsRecurring == true) {
                        $(".og-accounting-vatratestring input").val(NewValue + '%');
                        $(".og-accounting-vatrate input").val(NewValue);
                    }
                    else
                        Teva.SelectBox.GetInstance($(".og-accounting-vatrate input:hidden")).SetValue(NewValue, NewValue + "%");
                }


                if ($(".duedate .entitypicker").length > 0) {
                    var Terms = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms"];
                    if (Terms != null)
                        Teva.SelectBox.GetInstance($(".duedate .entitypicker")).SetValue(Terms.ID, Terms.Name, {
                            schemaid: Terms.SchemaID,
                            "Accounting.PaymentTerms.Days": !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.Days"],
                            "Accounting.PaymentTerms.DocumentDate": !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.DocumentDate"],
                            "Accounting.PaymentTerms.Months": !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.Months"]
                        });
                    else
                        Teva.SelectBox.GetInstance($(".duedate .entitypicker")).ClearValue();
                }
            }
            if (IsExternal == null || IsExternal != true) {
                var PaymentMethodSelectBox = Teva.SelectBox.GetInstance($(".og-billing-charge-paymentmethod-method input:hidden"));
                var ExistingSelectResult = null;
                for (var i = 0; i < PaymentMethodSelectBox.SelectConvertedResults.length; i++)
                    if (PaymentMethodSelectBox.SelectConvertedResults[i].id == "Existing")
                        ExistingSelectResult = PaymentMethodSelectBox.SelectConvertedResults[i];
                ExistingSelectResult.text = "";

                var SelectedHistoryPaymentMethodItem = null;
                if (HistoryPaymentMethods != null) {
                    for (var i = 0; i < PaymentMethodSelectBox.SelectConvertedResults.length; i++) {
                        if (PaymentMethodSelectBox.SelectConvertedResults[i].id == null)
                            PaymentMethodSelectBox.SelectConvertedResults.splice(i--, 1);
                    }

                    var HistoryPaymentMethodGroup = {
                        text: "אמצעי תשלום ישנים שאינם פעילים",
                        //cssClass: $(this).attr("class"),
                        children: []
                    };

                    var IsCredit = $(".og-billing-charge-paymentmethod-method").hasClass("og-billing-charge-paymentmethod-method-credit");
                    for (var i = 0; i < HistoryPaymentMethods.length; i++) {
                        var HistoryPaymentMethod = HistoryPaymentMethods[i];
                        if (ActivePaymentMethod != null && ActivePaymentMethod.ID == HistoryPaymentMethod.ID)
                            continue;
                        if (IsCredit && HistoryPaymentMethod.SchemaID != Billing.SchemaID_CreditCardPaymentMethod)
                            continue;

                        var HistoryPaymentMethodItem = {
                            id: "History",
                            text: HistoryPaymentMethod.Name,
                            data: {
                                PaymentMethodID: HistoryPaymentMethod.ID,
                                SchemaID: HistoryPaymentMethod.SchemaID
                            }
                        };

                        HistoryPaymentMethodGroup.children.push(HistoryPaymentMethodItem);
                        if (HistoryPaymentMethodID == HistoryPaymentMethod.ID)
                            SelectedHistoryPaymentMethodItem = HistoryPaymentMethodItem;
                    }
                    if (HistoryPaymentMethodGroup.children.length > 0)
                        PaymentMethodSelectBox.SelectConvertedResults.push(HistoryPaymentMethodGroup);
                }
                if (ActivePaymentMethod != null) {
                    $(".og-billing-charge-paymentmethod-method input:hidden").toggleClass("existing-iscc", ActivePaymentMethod.SchemaID == Billing.SchemaID_CreditCardPaymentMethod);
                    ExistingSelectResult.text = ActivePaymentMethod.Name;
                }
                else if (PayingCustomer != null) {
                    $(".og-billing-charge-paymentmethod-method input:hidden").removeClass("existing-iscc");
                    ExistingSelectResult.text = "לקוח/ה משלמ/ת (" + PayingCustomer.Name + ")";
                }

                if (SelectedHistoryPaymentMethodItem != null) {
                    PaymentMethodSelectBox.SetValue("History", SelectedHistoryPaymentMethodItem.text, SelectedHistoryPaymentMethodItem.data, false);
                    $("#SetActive").prop("checked", false);
                }
                else if (ActivePaymentMethod != null) {
                    PaymentMethodSelectBox.SetValueFromQueryMethod("Existing");
                    ExistingSelectResult.data = { PaymentMethodID: ActivePaymentMethod.ID };
                }
                else if (PayingCustomer != null) {
                    $(".og-billing-charge-paymentmethod-method input:hidden").removeClass("existing-iscc");
                    PaymentMethodSelectBox.SetValueFromQueryMethod("Existing");
                }
            }
            if (CustomerCompanyNumber != null && CustomerCompanyNumber != "")
                $(".og-billing-charge-paymentmethod-directdebit-customerid input, .og-billing-charge-paymentmethod-creditcard-customerid input").val(CustomerCompanyNumber).trigger("change");
            $("#PaymentDetails_DirectDebit_FullName").val(CustomerName).trigger("change");
            if (BankNumber != null) {
                $(".og-billing-charge-paymentmethod-directdebit-bank input:hidden").val(BankNumber).trigger("change");
                var BankSelectBox = Teva.SelectBox.GetInstance($(".og-billing-charge-paymentmethod-directdebit-bank input:hidden"));
                if (BankSelectBox != null)
                    BankSelectBox.SetValue(BankNumber, BankNumber, null, BankNumber == null || BankNumber.length == 0);
            }
            if (BranchNumber != null)
                $(".og-billing-charge-paymentmethod-directdebit-branch input").val(BranchNumber).trigger("change");
            if (AccountNumber != null)
                $(".og-billing-charge-paymentmethod-directdebit-account input").val(AccountNumber).trigger("change");

            Billing.RefreshBillingPaymentMethod(false);
        }

        static RemoveItem($Element) {
            OfficeGuy.Forms.NestedForm_Remove('.items', 'Items', $Element.closest('tr').index());
            $Element.closest('tr').remove();

            if ($(".items").children().length == 0)
                $('.documentitemsfooter .table-basic-add-item').trigger('click');

            Apps.Accounting.CalculateItemTotals();
            return false;
        }

        static RefreshFuturePayment(): void {
            var FirstPaymentDate = Teva.DatePicker.GetDateFromString(<string>$('#FirstPaymentDate').val(), Teva.DatePickerMode.Date);
            var Now = new Date();
            Now = new Date(Now.getFullYear(), Now.getMonth(), Now.getDate());
            if (FirstPaymentDate == null)
                FirstPaymentDate = Now;
            else
                FirstPaymentDate = new Date(FirstPaymentDate.getFullYear(), FirstPaymentDate.getMonth(), FirstPaymentDate.getDate());
            Forms.ToggleDisableForm($(".billing-hide-future"), FirstPaymentDate <= Now);
        }

        static RefreshBillingPaymentMethod(IsInit: boolean): void {
            var $PaymentMethodInput = $(".og-billing-charge-paymentmethod-method input:hidden");
            var PaymentMethod = $PaymentMethodInput.val();
            if (IsInit && PaymentMethod == "Existing" && $PaymentMethodInput.find("option").length == 2 && $PaymentMethodInput.find("option").first().text() == "") {
                PaymentMethod = $($PaymentMethodInput.find("option")[1]).val();
                $PaymentMethodInput.val(PaymentMethod);
            }
            var PaymentMethodSelectBox = null;
            if ($PaymentMethodInput.length != 0)
                PaymentMethodSelectBox = Teva.SelectBox.GetInstance($PaymentMethodInput);

            var ExistingPaymentMethodIsCC = (PaymentMethod == "Existing" && $PaymentMethodInput.hasClass("existing-iscc")) || (PaymentMethod == "History" && PaymentMethodSelectBox.SelectedData.SchemaID == Billing.SchemaID_CreditCardPaymentMethod);

            Forms.ToggleDisableForm($(".og-billing-charge-paymentmethod-setactive"), PaymentMethod != "Existing", !IsInit);
            Forms.ToggleDisableForm($(".og-billing-charge-payments"), PaymentMethod == "CreditCard" || PaymentMethod == "CreditCardSwipe" || ExistingPaymentMethodIsCC || PaymentMethod == "Cash", !IsInit);
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-creditcard-number, .og-billing-charge-paymentmethod-creditcard-expiration, .og-billing-charge-paymentmethod-creditcard-customerid'), PaymentMethod == "CreditCard", !IsInit);
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-creditcard-cvv'), PaymentMethod == "CreditCard" || ExistingPaymentMethodIsCC, !IsInit);
            $('.og-billing-charge-paymentmethod-creditcard-number, .og-billing-charge-paymentmethod-creditcardswipe-track2').closest(".sumit-field-horizontalcontainer");
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-creditcardswipe-track2, .og-billing-charge-paymentmethod-creditcardswipe-cvv, .og-billing-charge-paymentmethod-creditcardswipe-citizenid'), PaymentMethod == "CreditCardSwipe", !IsInit);
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-directdebit'), PaymentMethod == "DirectDebit", !IsInit);
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-remove'), PaymentMethod == "Remove", !IsInit);

            var PaymentsCount = Number(<string>$("input.og-billing-charge-payments-count").val());
            var Total = Number(<string>$("input.og-accounting-items-totalcompanyvaluewithvat").val());
            var IsPayments = PaymentsCount > 1;
            var IsPaymentsCredit = IsPayments && $("#CreditCard_PaymentsCredit").length > 0 && $("#CreditCard_PaymentsCredit").prop("checked");
            Forms.ToggleSlide($(".og-billing-charge-payments-details"), IsPayments, !IsInit);
            Forms.ToggleSlide($(".og-billing-charge-payments-details-amounts"), IsPayments && !IsPaymentsCredit && Total != 0, !IsInit);

            if (PaymentMethodSelectBox != null) {
                if (PaymentMethodSelectBox.SelectedValue == "History") {
                    if ($("#SetActive").prop("checked")) {
                        var $Modal = Modals.ShowConfirmDialog({
                            Title: "שימוש באמצעי תשלום ישן",
                            Message: 'לתשומת הלב, על מנת לשמור את הכרטיס כאמצעי התשלום הקבוע של הלקוח/ה יש לסמן את הכפתור "שמירת אמצעי תשלום" תחת "אפשרויות נוספות" בתחתית המסך.<br />בברירת המחדל, בחירת אמצעי תשלום שאינו פעיל אינה שומרת אותו כאמצעי הפעיל של הלקוח/ה.',
                            ConfirmText: "אישור",
                            ConfirmEvent: function () {
                                Modals.Hide($Modal);
                                return false;
                            }
                        });
                        $("#SetActive").prop("checked", false);
                    }
                    $("#PaymentMethodID").val(PaymentMethodSelectBox.SelectedData.PaymentMethodID);
                }

                var ValidValuesCount = 0;
                var ValidValue = null;
                for (var i = 0; i < PaymentMethodSelectBox.SelectConvertedResults.length; i++)
                    if (PaymentMethodSelectBox.SelectConvertedResults[i].text != "") {
                        ValidValuesCount++;
                        ValidValue = PaymentMethodSelectBox.SelectConvertedResults[i];
                    }
                if (ValidValuesCount == 1)
                    PaymentMethodSelectBox.SetValue(ValidValue.id, ValidValue.text, ValidValue.data);

                $(".og-billing-charge-paymentmethod-method").toggle(ValidValuesCount != 1);
            }
        }

        static RefreshExternalPaymentMethod(): void {
            var $Hide = $("input[name='PaymentDetails.Provider']:not(:checked)").closest(".sumit-field").closest(".og-purchasepages-paymentdetails").removeClass("og-purchasepages-paymentdetails-active").find('.og-purchasepages-paymentdetails-details');
            var $Show = $("input[name='PaymentDetails.Provider']:checked").closest(".sumit-field").closest(".og-purchasepages-paymentdetails").addClass("og-purchasepages-paymentdetails-active").find('.og-purchasepages-paymentdetails-details');
            OfficeGuy.Forms.ToggleDisableForm($Show, true, true);
            OfficeGuy.Forms.ToggleDisableForm($Hide, false, true);
            //Teva.SlideOrFade.Show($Show, 200);
            //Teva.SlideOrFade.Hide($Hide, 200);
        }

        static InitPayments(): void {
            $("input.og-accounting-items-totalcompanyvaluewithvat").on("change.billingpayments", function () {
                Billing.RefreshPayments($(this));
            });
            $(".og-billing-charge-payments-details input").on("input", function () {
                Billing.RefreshPayments($(this));
            });
            $(".documentitems").on("input", ".og-accounting-items-recurrence input", function () {
                Billing.RefreshPayments($(this));
            });
            Billing.RefreshPayments($(this));
        }

        static IgnorePaymentsEvents = false;
        static RefreshPayments(Initiator): void {
            if (Billing.IgnorePaymentsEvents)
                return;

            if ($(".og-accounting-items-totalalltime").length > 0) {
                if ($("input.og-accounting-items-totalcompanyvaluewithvat").val() == "")
                    $("input.og-accounting-items-totalalltime").val("");
                else {
                    var VATMultiplier: number;
                    if ($(".og-accounting-vatrate input:hidden").length > 0)
                        VATMultiplier = (Number($(".og-accounting-vatrate input:hidden:last").val()) + 100) / 100;
                    else
                        VATMultiplier = (Number($("input.og-accounting-items-totalcompanyvaluewithvat").attr("data-missingvat")) + 100) / 100;

                    var VATIncluded = $(".og-accounting-vatincluded input").prop("checked") || $(".og-accounting-vatincluded input").val() == "True";
                    var TotalAllTime = 0;
                    $(".documentitem").each(function () {
                        var CompanyValue = <string>$(".og-accounting-items-companyvalue input", $(this)).val();
                        var Recurrence = <string>$(".og-accounting-items-recurrence input", $(this)).val();

                        if (!Accounting.IsNumber(CompanyValue) || !Accounting.IsNumber(Recurrence))
                            TotalAllTime = null;
                        else if (TotalAllTime != null) {
                            if (VATIncluded)
                                TotalAllTime += Number(CompanyValue) * Number(Recurrence);
                            else
                                TotalAllTime += Common.RoundTwoPoints(Number(CompanyValue) * VATMultiplier) * Number(Recurrence);
                        }
                    });

                    var Currency = $(".og-accounting-currency input.currencypicker").val();
                    $("input.og-accounting-items-totalalltime").val(TotalAllTime == null ? "∞" : Common.RoundTwoPoints(TotalAllTime)).trigger("change");
                    $("span.og-accounting-items-totalalltime").html(TotalAllTime == null ? "∞" : Accounting.FormatCurrencySummary(Common.RoundTwoPoints(TotalAllTime), Currency));
                }
            }

            var PaymentsCount = Number(<string>$("input.og-billing-charge-payments-count").val());
            var Total = Number(<string>$("input.og-accounting-items-totalcompanyvaluewithvat").val());
            var IsPayments = PaymentsCount > 1;
            var IsPaymentsCredit = IsPayments && $("#CreditCard_PaymentsCredit").length > 0 && $("#CreditCard_PaymentsCredit").prop("checked");
            $(".og-billing-charge-payments-details").toggle(IsPayments);
            $(".og-billing-charge-payments-details-amounts").toggle(IsPayments && !IsPaymentsCredit && Total != 0);

            var $FirstPaymentElement = $("#CreditCard_FirstPaymentAmount");
            var $EachPaymentElement = $("#CreditCard_EachPaymentAmount");
            if ($FirstPaymentElement.val() != '' && !isNaN(Number(<string>$FirstPaymentElement.val()))
                && $EachPaymentElement.val() != '' && !isNaN(Number(<string>$EachPaymentElement.val()))
                && Number($FirstPaymentElement.val()) + (PaymentsCount - 1) * Number($EachPaymentElement.val()) == Total) {
                return;
            }

            Billing.IgnorePaymentsEvents = true;
            if (Initiator != null && Initiator[0] == $FirstPaymentElement[0]) {
                var EachPayment = Math.round(100 * (Total - Number($FirstPaymentElement.val())) / (PaymentsCount - 1)) / 100;
                var FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                if (EachPayment <= 0 || FirstPayment <= 0) {
                    EachPayment = Math.round(100 * Total / PaymentsCount) / 100;
                    FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                }
                $FirstPaymentElement.val(FirstPayment.toString()).trigger("input");
                $EachPaymentElement.val(EachPayment.toString()).trigger("input");
            }
            else if (Initiator != null && Initiator[0] == $EachPaymentElement[0]) {
                var EachPayment = Math.round(100 * Number($EachPaymentElement.val())) / 100;
                var FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                if (EachPayment <= 0 || FirstPayment <= 0) {
                    EachPayment = Math.round(100 * Total / PaymentsCount) / 100;
                    FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                }
                $FirstPaymentElement.val(FirstPayment.toString()).trigger("input");
                $EachPaymentElement.val(EachPayment.toString()).trigger("input");
            }
            else {
                var EachPayment = Math.round(100 * Total / PaymentsCount) / 100;
                var FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                if (EachPayment <= 0 || FirstPayment <= 0) {
                    EachPayment = Math.round(100 * Total / PaymentsCount) / 100;
                    FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                }
                $FirstPaymentElement.val(FirstPayment.toString()).trigger("input");
                $EachPaymentElement.val(EachPayment.toString()).trigger("input");
            }
            Billing.IgnorePaymentsEvents = false;
        }

        static ProcessRecurringUpdateSelected() {
            $("#AllowedCustomerRecurringItemIDs").val(Billing.ProcessRecurringGetCheckedString($("input[name=CustomerRecurringItemID]:checked")));
            $("#AllowedDirectDebitPaymentIDs").val(Billing.ProcessRecurringGetCheckedString($("input[name=DirectDebitPaymentID]:checked")));
            $("#AllowedDocumentIDs").val(Billing.ProcessRecurringGetCheckedString($("input[name=DocumentID]:checked")));
        }
        static ProcessRecurringGetCheckedString($Inputs) {
            var ToReturn = "";
            $Inputs.each(function () {
                ToReturn += "," + $(this).val();
            });
            if (ToReturn.length != 0)
                ToReturn = ToReturn.substring(1);
            return ToReturn;
        }

        static ProcessRecurringRefreshSelected() {
            // AllowedCustomerRecurringItemIDs
            var AllowedCustomerRecurringItemIDs = (<string>$("#AllowedCustomerRecurringItemIDs").val()).split(',')
            $("input[name=CustomerRecurringItemID]").each(function () {
                if (AllowedCustomerRecurringItemIDs.indexOf($(this).val().toString()) != -1)
                    $(this).prop("checked", true);
            });

            // AllowedDirectDebitPaymentIDs
            var AllowedDirectDebitPaymentIDs = (<string>$("#AllowedDirectDebitPaymentIDs").val()).split(',')
            $("input[name=DirectDebitPaymentID]").each(function () {
                if (AllowedDirectDebitPaymentIDs.indexOf($(this).val().toString()) != -1)
                    $(this).prop("checked", true);
            });

            // AllowedDocumentIDs
            var AllowedDocumentIDs = (<string>$("#AllowedDocumentIDs").val()).split(',');
            $("input[name=DocumentID]").each(function () {
                if (AllowedDocumentIDs.indexOf($(this).val().toString()) != -1)
                    $(this).prop("checked", true);
            });

            // Select thead checkbox
            $("table").each(function () {
                var $Table = $(this);
                if ($Table.find("tbody input[type=checkbox]:not(:checked)").length == 0)
                    $Table.find("thead input[type=checkbox]").prop("checked", true);
            });
        }

        static RefreshCreditCompany() {
            var CreditGuy = $("#CreditCompany").val() == "2";
            $(".og-billing-creditguy").toggle(CreditGuy);
            $(".og-billing-creditcompany").toggle(!CreditGuy);
        }

        static ActivateCreditGuyTerminal(): boolean {
            OfficeGuy.Modals.ShowConfirmDialog({
                Title: "התחלת סליקות בפועל",
                Message: "המסוף שלך מוכן לפעולה. אם ברצונך לסיים את שלב הבדיקות ולעבור לסליקה בפועל?",
                ConfirmEvent: "/creditcard/activateterminal/"
            });

            return false;
        }

        static RecurringItemSelected($EntityPicker): void {
            var DocumentItem = $EntityPicker.closest(".documentitem");
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            if (SelectBox.ChangeEventFromInit) {
                if ((DocumentItem.find(".og-accounting-items-unitdocumentvalue input").val() != null && DocumentItem.find(".og-accounting-items-unitdocumentvalue input").val() != "") || DocumentItem.find(".og-accounting-items-unitcompanyvalue input").val() != "")
                    return;
            }
            var Data = SelectBox.SelectedData
            var DocumentValue = "", CompanyValue = "", Recurrence = "";
            if (Data != null) {
                CompanyValue = !Data.AdditionalFields ? "" : Data.AdditionalFields["Accounting.IncomeItems.Price"];
                Recurrence = !Data.AdditionalFields ? "" : Data.AdditionalFields["Billing.Bundles.DefaultRecurrence"];
            }
            if (Accounting.PricesIncludeVAT && Accounting.SelectedCustomer_NoVAT) {
                var VATRate = Number($(".og-accounting-vatrate input:hidden").data("originalvalue"));
                if (CompanyValue != "")
                    CompanyValue = Common.RoundTwoPoints(Number(CompanyValue) / (1 + VATRate / 100)).toString();
                if (DocumentValue != "")
                    DocumentValue = Common.RoundTwoPoints(Number(DocumentValue) / (1 + VATRate / 100)).toString();
            }
            DocumentItem.find(".og-accounting-items-unitdocumentvalue input").val(DocumentValue);
            DocumentItem.find(".og-accounting-items-unitcompanyvalue input").val(CompanyValue);
            DocumentItem.find(".og-accounting-items-recurrence input").val(Recurrence);
            DocumentItem.find(".og-accounting-items-unitdocumentvalue input").trigger("input");
            DocumentItem.find(".og-accounting-items-unitcompanyvalue input").trigger("input");
            DocumentItem.find(".og-accounting-items-recurrence input").trigger("input");
            if (Data && Data.AdditionalFields != null && Data.AdditionalFields["Accounting.IncomeItems.Description"] && Data.AdditionalFields["Accounting.IncomeItems.Description"] != "")
                DocumentItem.find(".og-accounting-items-description textarea").val(Data.AdditionalFields["Accounting.IncomeItems.Description"]).trigger("change");
        }

        static ChargeFromDocument(ID, ShowWarning: boolean = false): boolean {
            if (ShowWarning) {
                var $Modal = Modals.ShowConfirmDialog({
                    Title: "יצירת חיוב מקושר",
                    Message: "לתשומת הלב, מתוך המסמך הנוכחי נוצר מסמך בעבר. האם ברצונך להמשיך ליצירת חיוב מקושר למסמך?",
                    ConfirmText: "המשך ליצירה",
                    ConfirmEvent: function () {
                        Modals.Hide($Modal);
                        Billing.ChargeFromDocument(ID);
                        return false;
                    }
                });
                return false;
            }

            Navigation.Redirect("/billing/charge/?documentid=" + ID);
            return false;
        }

        static ProcessBillingSelectedRecurringItems() {
            Modals.ShowConfirmDialog({
                Title: "חיוב הוראות הקבע המסומנות",
                Message: "האם ברצונך לחייב את הוראות הקבע שסומנו?<br /><br />לתשומת הלב!<br /><ol><li>על מנת לבצע את החיוב בפועל, יש ללחוץ על כפתור \"חיוב הוראות קבע\" במסך הבא.</li><li>לא ניתן לחייב בשיטה זו הוראות קבע שתאריך החיוב הבא שלהם הינו בעתיד, והן לא יחוייבו.</li></ol>",
                ConfirmText: "המשך לחיוב",
                ConfirmEvent: function () {
                    var EntityIDs = OfficeGuy.CRM.EntitiesList.SelectedEntities_GetSelected();
                    Navigation.Redirect("/recurringbilling/process/?allowedcustomerrecurringitemids=" + EntityIDs);
                    return false;
                }
            });
            return false;
        }

        static RecurringCharge_DateChanged($Input) {
            Teva.DatePicker.InputChange($Input);

            var Value = Teva.DatePicker.GetDateFromString($Input.val(), Teva.DatePickerMode.Date);
            if (Value == null || Value.getFullYear() < 1900)
                return;

            var Range_From = new Date();
            Range_From.setDate(Range_From.getDate() - 1);
            if (Value < Range_From)
                OfficeGuy.Modals.ShowMessageDialog("תאריך החיוב הראשון", "לתשומת הלב, המערכת שמה לב שהוזן תאריך חיוב ראשון בעבר.<br />מצב זה יכול לגרום למספר חיובים ברצף.<br />מומלץ לוודא כי אתם מבינים איך עובד חיוב בעבר. <a target=\"_blank\" href=\"https://help.sumit.co.il/he/articles/5799371\">לקריאה נוספת »</a>");
            if ($(".duedate .entitypicker").length > 0)
                Accounting.AccountingTermsSelected($(".duedate .entitypicker"));
        }

        static PreSubmitEnter(FormSelector) {
            var $Modal = Modals.ShowConfirmDialog({
                Title: "יצירת חיוב חד פעמי",
                Message: "האם לבצע את החיוב?",
                ConfirmEvent: function () {
                    Billing.PreSubmit();
                    OfficeGuy.Forms.SubmitForm(FormSelector);
                    Modals.Hide($Modal);
                    return false;
                },
                CancelAllowed: true
            });
            return false;
        }
        static PreSubmitEnterRecurring(FormSelector) {
            var $Modal = Modals.ShowConfirmDialog({
                Title: "יצירת הוראת קבע",
                Message: "האם ליצור את הוראת הקבע?",
                ConfirmEvent: function () {
                    OfficeGuy.Forms.SubmitForm(FormSelector);
                    Modals.Hide($Modal);
                    return false;
                },
                CancelAllowed: true
            });
            return false;
        }
        static PreSubmitEnterCredit(FormSelector) {
            var $Modal = Modals.ShowConfirmDialog({
                Title: "יצירת זיכוי ללקוח/ה",
                Message: "האם לבצע את הזיכוי?",
                ConfirmEvent: function () {
                    Billing.PreSubmit();
                    OfficeGuy.Forms.SubmitForm(FormSelector);
                    Modals.Hide($Modal);
                    return false;
                },
                CancelAllowed: true
            });
            return false;
        }

        static PreSubmit() {
            var $HiddenContainer = $(".documentitems_hidden").empty();
            var Index = $(".documentitems tbody tr").length;

            var Discount_Value = $("#og-accounting-items-discountcompanyvalue").data("absolute") == null ? Number($("#og-accounting-items-discountcompanyvalue").val()) : <Number>$("#og-accounting-items-discountcompanyvalue").data("absolute");
            if (Discount_Value != 0) {
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].UnitValue")
                    .val((-Discount_Value).toString()));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].Value")
                    .val((-Discount_Value).toString()));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].Quantity")
                    .val("1"));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].Element.ID")
                    .val(Accounting.DiscountElementID.toString()));
                Index++;
            }

            var Rounding_Value = Number($(".og-accounting-items-roundingcompanyvalue[type=hidden]").val());
            if (Rounding_Value != 0) {
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].UnitValue")
                    .val(Rounding_Value.toString()));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].Value")
                    .val(Rounding_Value.toString()));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].Quantity")
                    .val("1"));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Items[" + Index + "].Element.ID")
                    .val(Accounting.RoundingElementID.toString()));
                Index++;
            }
        }

        static ShowEmailDocument(PaymentID, DocumentID, CustomerItemID, PaymentMethodID, CustomerID, IsCredit) {
            OfficeGuy.Modals.ShowURLModal("/billing/emaildocument/?paymentid=" + PaymentID + "&documentid=" + DocumentID + "&customeritemid=" + CustomerItemID + "&paymentmethodid=" + PaymentMethodID + "&customerid=" + CustomerID + "&iscredit=" + IsCredit);
            return false;
        }

        static InitUpdateDates(DurationDays, DurationMonths) {
            var $Input_Next = $('#Date_NextBilling');
            var $Input_Pending = $('#Pending');
            var $Input_Last = $('#Date_Last');
            $Input_Next.on("change", function () {
                Teva.DatePicker.InputChange($(this));
                var Next_Value = Teva.DatePicker.GetDateFromString(<string>$Input_Next.val(), Teva.DatePickerMode.Date);
                if ($Input_Pending.val() != "") {
                    var Pending_Value = Number($Input_Pending.val());
                    var Last_Value = Billing.GetLastDate(Next_Value, Pending_Value, DurationDays, DurationMonths);
                    $Input_Last.val(Teva.DatePicker.GetDateAsString(Last_Value));
                }
                return false;
            });
            $Input_Pending.on("input", function () {
                var Pending_Value = Number($Input_Pending.val());
                if ($Input_Pending.val() == "" || Pending_Value < 0) {
                    $Input_Pending.val("");
                    $Input_Last.val("").trigger("change.sumit-field");
                    return false;
                }

                var Next_Value = Teva.DatePicker.GetDateFromString(<string>$Input_Next.val(), Teva.DatePickerMode.Date);
                var Last_Value = Billing.GetLastDate(Next_Value, Pending_Value, DurationDays, DurationMonths);
                $Input_Last.val(Teva.DatePicker.GetDateAsString(Last_Value)).trigger("change.sumit-field");
                return false;
            });
            $Input_Last.on("change", function () {
                Teva.DatePicker.InputChange($(this));
                if ($Input_Last.val() == "") {
                    $Input_Pending.val("").trigger("change.sumit-field");
                    return false;
                }
                var Next_Value = Teva.DatePicker.GetDateFromString(<string>$Input_Next.val(), Teva.DatePickerMode.Date);
                var Last_Value = Teva.DatePicker.GetDateFromString(<string>$Input_Last.val(), Teva.DatePickerMode.Date);
                if (Last_Value < Next_Value)
                    Last_Value = Next_Value;
                var Pending_Value = 1;
                var Last_CorrectValue = Next_Value;
                while (Last_CorrectValue < Last_Value) {
                    Pending_Value++;
                    Last_CorrectValue.setDate(Last_CorrectValue.getDate() + DurationDays);
                    Last_CorrectValue.setMonth(Last_CorrectValue.getMonth() + DurationMonths);
                    if (Last_CorrectValue > Last_Value) {
                        Last_CorrectValue.setDate(Last_CorrectValue.getDate() - DurationDays);
                        Last_CorrectValue.setMonth(Last_CorrectValue.getMonth() - DurationMonths);
                        Pending_Value--;
                        break;
                    }
                }
                $Input_Last.val(Teva.DatePicker.GetDateAsString(Last_CorrectValue));
                $Input_Pending.val(Pending_Value).trigger("change.sumit-field");
                return false;
            });
        }
        static GetLastDate(NextDate: Date, Pending: number, DurationDays: number, DurationMonths: number): Date {
            NextDate.setDate(NextDate.getDate() + DurationDays * (Pending - 1));
            NextDate.setMonth(NextDate.getMonth() + DurationMonths * (Pending - 1));
            return NextDate;
        }

        static InitUpdateValues() {
            var $PriceInput = $('#Price');
            var $QuantityInput = $('#Quantity');
            var $TotalInput = $('#Total');
            $PriceInput.on("input", function () {
                var Price = Number($PriceInput.val());
                var Quantity = Number($QuantityInput.val());
                if (!isNaN(Price) && !isNaN(Quantity))
                    $TotalInput.val(Price * Quantity).trigger("change.sumit-field");
                else
                    $TotalInput.val("").trigger("change.sumit-field");
                return false;
            });
            $QuantityInput.on("input", function () {
                var Price = Number($PriceInput.val());
                var Quantity = Number($QuantityInput.val());
                if (!isNaN(Price) && !isNaN(Quantity))
                    $TotalInput.val(Price * Quantity).trigger("change.sumit-field");
                else
                    $TotalInput.val("").trigger("change.sumit-field");
                return false;
            });
            $TotalInput.on("input", function () {
                var Total = Number($TotalInput.val());
                var Quantity = Number($QuantityInput.val());
                if (!isNaN(Total) && !isNaN(Quantity) && Quantity > 0) {
                    var Price = Math.round(100 * Total / Quantity) / 100;
                    $PriceInput.val(Price).trigger("change");
                }
                else
                    $PriceInput.val("").trigger("change.sumit-field");
                return false;
            });
        }

        static InitCreditCardWizard() {
            Teva.SelectBox.Enable($(".og-creditcard-wizard-upay-city input"), {
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    Common.AjaxRequest({
                        Method: 'GET',
                        URL: "/creditcard/citypicker/",
                        SuccessMethod: function (Response) {
                            var data = {
                                results: [],
                                more: false
                            };
                            for (var i = 0; i < Response.length; i++)
                                data.results.push({ id: Response[i], text: Response[i] });
                            data.results = Teva.SelectBox.FilterResults(data.results, Query, QueryByID);
                            Callback(data, Query);
                        },
                    });
                },
                OnChange: function (Value) {
                    var AddressPicker = Teva.SelectBox.GetInstance($(".og-creditcard-wizard-upay-address input[type=hidden]"));
                    if (Value == null || Value == "")
                        AddressPicker.Disable();
                    else
                        AddressPicker.Enable();
                    AddressPicker.ClearValue();
                    AddressPicker.ClearCache();
                }
            });

            Teva.SelectBox.Enable($(".og-creditcard-wizard-upay-address input"), {
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    Common.AjaxRequest({
                        Method: 'GET',
                        URL: "/creditcard/addresspicker/?city=" + $(".og-creditcard-wizard-upay-city input[type=hidden]").val(),
                        SuccessMethod: function (Response) {
                            var data = {
                                results: [],
                                more: false
                            };
                            for (var i = 0; i < Response.length; i++)
                                data.results.push({ id: Response[i], text: Response[i] });
                            data.results = Teva.SelectBox.FilterResults(data.results, Query, QueryByID);
                            Callback(data, Query);
                        },
                    });
                },
            });

            if ($(".og-creditcard-wizard-upay-city input[type=hidden]").val() == "")
                Teva.SelectBox.GetInstance($(".og-creditcard-wizard-upay-address input[type=hidden]")).Disable();

            Teva.SelectBox.Enable($(".og-creditcard-wizard-upay-yellowpages input"), {
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    Common.AjaxRequest({
                        Method: 'GET',
                        URL: "/creditcard/yellowpagepicker/",
                        SuccessMethod: function (Response) {
                            var data = {
                                results: [],
                                more: false
                            };
                            for (var i = 0; i < Response.length; i++)
                                data.results.push({ id: Response[i], text: Response[i] });
                            data.results = Teva.SelectBox.FilterResults(data.results, Query, QueryByID);
                            Callback(data, Query);
                        },
                    });
                },
            });
        }

        static InitTrack2() {
            $('.og-billing-charge-paymentmethod-creditcardswipe-track2 input')
                .val("")
                .each(function () {
                    var $Input = $(this);
                    var $Hidden = $(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", $Input.attr("name"))
                        .insertAfter($Input);

                    $Input
                        .data("Track2HiddenField", $Hidden[0])
                        .attr("name", "");
                })
                .on("keyup", function (Event) {
                    var $Element = $(this);
                    var Buffer = $Element.data("Track2Buffer");
                    if (Buffer == null)
                        Buffer = "";
                    if (Event.key == "Enter")
                        return Buffer.length == 0;

                    var Timer = $Element.data("Timer");
                    if (Timer != null)
                        clearTimeout(Timer);

                    $Element.data("Timer", setTimeout(function () {
                        Billing.Track2Timeout($Element);
                    }, 100));

                    Buffer += $Element.val();
                    $Element.val("");
                    $Element.data("Track2Buffer", Buffer);
                    return false;
                })
                .on("keypress", function (Event) {
                    var $Element = $(this);
                    var Buffer = $Element.data("Track2Buffer");
                    if (Buffer == null)
                        Buffer = "";
                    if (Event.key == "Enter")
                        return Buffer.length == 0;

                    var Timer = $Element.data("Timer");
                    if (Timer != null)
                        clearTimeout(Timer);

                    $Element.data("Timer", setTimeout(function () {
                        Billing.Track2Timeout($Element);
                    }, 100));

                    Buffer += String.fromCharCode(Event.which);
                    $Element.data("Track2Buffer", Buffer);
                    return false;
                });
        }
        static Track2Timeout($Element) {
            var Buffer = $Element.data("Track2Buffer");
            if (Buffer.length <= 1) {
                $($Element.data("Track2HiddenField")).val("");
                $Element.val("");
                return;
            }
            Buffer = Buffer.replace(/ף/g, ";");
            var Parts = Buffer.split('?')
            var Track2 = null;
            if (Parts.length > 1 && Parts[1].length > 0 && Parts[1][0] == ';')
                Track2 = Parts[1].substr(1);
            else if (Parts.length == 1 && Parts[0].length > 0 && Parts[0].indexOf('=') != -1)
                Track2 = Parts[0];
            else if (Parts.length == 2 && Parts[0].length > 0 && Parts[0].indexOf('=') != -1 && Parts[1].length == 0)
                Track2 = Parts[0];
            if (Track2 != null) {
                $($Element.data("Track2HiddenField")).val(Track2);
                $Element.val(Track2.substr(Track2.indexOf('=') - 4, 4));
            }
            else {
                OfficeGuy.Notifications.Show([{
                    Text: "ארעה שגיאה בקריאת הכרטיס",
                }]);
                $($Element.data("Track2HiddenField")).val("");
                $Element.val("");
            }
            $Element.data("Track2Buffer", "")
        }

        static RefreshRecurringBillingSettings() {
            var $Failures = $('div[og-settings-key=Failure_Skip], div[og-settings-parentkey=Failure_Skip]');
            if ($('div[og-settings-key=Failure_Mode] input:last').val() == '1' || $('div[og-settings-key=Failure_Mode] input:last').val() == '2') {
                $Failures.find('input').prop('checked', $('div[og-settings-key=Failure_Mode] input:last').val() == '2');
                $Failures.hide();
            }
            else {
                $('div[og-settings-key="Failure_Skip"]').show();
                $Failures.find("input").trigger("change");
            }
        }
    }
}